import { render, staticRenderFns } from "./Producto.vue?vue&type=template&id=84954952&scoped=true"
import script from "./Producto.vue?vue&type=script&lang=js"
export * from "./Producto.vue?vue&type=script&lang=js"
import style0 from "./Producto.vue?vue&type=style&index=0&id=84954952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84954952",
  null
  
)

export default component.exports